"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.credit.description': 'Konfiguruj kursy wymiany kredytów dla usług AI',
    'settings.credit.failedToLoad': 'Błąd ładowania ustawień kredytów',
    'settings.credit.savedSuccessfully': 'Ustawienia kredytów zapisane pomyślnie',
    'settings.credit.failedToSave': 'Błąd zapisywania ustawień kredytów',
    'settings.credit.save': 'Zapisz Ustawienia Kredytów',
    'settings.credit.reload': 'Odśwież',
    'settings.credit.credits': 'kredytów',
    'settings.credit.conversion.title': 'Konwersja Waluty',
    'settings.credit.conversion.dollarToCreditRate': 'Kredyty za USD',
    'settings.credit.conversion.dollarToCreditRate.help': 'Ile kredytów równa się 1 USD. To wpływa na ceny wszystkich operacji AI.',
    'settings.credit.preview.title': 'Podgląd Konwersji',
    'settings.credit.warning.title': 'Ważna Informacja',
    'settings.credit.warning.description': 'Zmiany w kursach kredytów wpłyną na wszystkie przyszłe operacje AI. Istniejące kredyty użytkowników nie zostaną zmienione.',
};
